import { NgStyle } from '@angular/common';
import { Component, ElementRef, afterNextRender, computed, effect, inject, signal, viewChild } from '@angular/core';

import { BreakPointManager } from '@23degrees/shared/manager/breakpoint/breakpoint.manager';

import { LayoutElementComponent } from '../layout-element/layout-element.component';

@Component({
  selector: 'layout-logo',
  templateUrl: './layout-logo.component.html',
  styleUrls: ['./layout-logo.component.scss'],
  imports: [NgStyle],
})
export class LayoutLogoComponent extends LayoutElementComponent {
  private breakPointManager = inject(BreakPointManager);

  readonly fallbackLogo = viewChild<ElementRef<HTMLElement>>('fallbackLogo');

  constructor() {
    super();

    afterNextRender(() => {
      if (!this.logoState().image) {
        // this.emitRenderStatus('logoReady');
      }
    });

    effect(() => {
      if (this.fallbackLogo()) {
        this.emitRenderStatus('logoReady');
      }
    });
  }

  public logoState = computed(() => {
    const { logo, vUserInfo } = this.content();
    const logoSrc = logo ?? vUserInfo?.userPreferences.defaultContentLogo;

    return {
      error: signal(false),
      image: logoSrc ? this.globalService.escapeMediaLink(logoSrc) : undefined,
    };
  });

  public logoSrc = computed(() => {
    const { logo, vUserInfo } = this.content();
    const logoSrc = logo ?? vUserInfo?.userPreferences.defaultContentLogo;
    return logoSrc ? this.globalService.escapeMediaLink(logoSrc) : undefined;
  });

  // user = resource({
  //   request: this.logoSrc,
  //   loader: async ({ request: id }) => await userService.getUser(id),
  // });

  public containerStyle = computed(() => {
    // content gets the update signal, data is stored in layout -> child options
    const content = this.content();

    const { margin, padding } = this.childOptions();
    const style = {
      display: 'flex',
      margin: this.responsiveStylePipe.transform(margin, 'spacing'),
      padding: this.responsiveStylePipe.transform(padding, 'spacing'),
    };

    return style;
  });

  public logoStyle = computed(() => {
    // content gets the update signal, data is stored in layout -> child options
    const content = this.content();

    const { width, height, borderRadius, boxShadow } = this.childOptions();

    let sizeFactor = 1;
    if (!this.content().typeSpecific.layout.oldLayoutStyle) {
      sizeFactor = this.breakPointManager.getSizeFactor(this.content().slug);
    }

    const scaledHeight = height * sizeFactor;

    const style = {
      display: 'inline-flex',
      // width: width + 'px',
      // width: 'fit-content',
      // minWidth: 'max-content',
      // maxWidth: 'fit-content',
      objectFit: 'cover', // TODO maybe?
      height: `${scaledHeight}px`,
      borderRadius: `${borderRadius}px`,
      boxShadow: this.responsiveStylePipe.transform(boxShadow, 'shadow'),
    };

    const fallbackLogo = this.fallbackLogo();
    if (fallbackLogo) {
      const fontSize = scaledHeight; // Math.min(width, height);
      fallbackLogo.nativeElement.style.setProperty('--logo-font-size', `${fontSize}px`);
    }

    return style;
  });

  imgLoad(event: Event) {
    this.emitRenderStatus('logoReady');
  }

  imgError(event: ErrorEvent) {
    this.logoState().error.set(true);
    this.emitRenderStatus('logoReady');
  }
}
